import { useState, useEffect } from 'react';
import { Route, Routes, useLocation, useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import './navigation.css';
import HeaderComponent from './header/headerComponent';
import { dataProfile, dataSummary } from '../store/data/actions';
import { getProfile } from '../store/auth/actions';
import { getOperations } from '../store/realestate/actions';
import queryString from 'query-string';
import TagManager from './tagmanager';
import LoginPage from '../Pages/auth/login';
import ForgotPasswordPage from '../Pages/auth/forgot';
import RestorePage from '../Pages/auth/restore';
import { isMobileOnly } from 'react-device-detect';
import LoaderLogo from './LoaderLogo';
import { Layout } from 'antd';
import AlertPassword from './alerts/AlertPassword';
import OnboardingNav from '../Pages/onboarding/OnboardingNav';
import OperationStage from '../Pages/onboarding/OperationStages';
import RedirectToSabadell from '../Pages/onboarding/Pages/RedirectToSabadell';
import Home from './core/Home';
import { useAnalytics } from 'use-analytics';
import AutomaticDocumentation from '../Pages/Operaciones/documentation/AutomaticDocumentation/AutomaticDocumentation';
import OpenData from '../Pages/Operaciones/documentation/OpenData';
import OfferDocuments from './widgets/Different-Widgets/offerDocuments';
import jwt_decode from 'jwt-decode';
import axios from 'axios';
import Help from '../Pages/help/help';
import Payments from '../Pages/Operaciones/documentation/Payments';

const { Content } = Layout;

const Navigation = () => {
	const dispatch = useDispatch();
	const analytics = useAnalytics();
	const navigate = useNavigate();
	const location = useLocation();
	const [loading, setLoading] = useState(true);
	const userToken = useSelector((state) => state.auth.token);
	const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);
	const changeStages = useSelector((state) => state.auth.refreshStages);
	const rol = useSelector((state) => state.auth.roles);
	const query = queryString.parse(location.search);
	const profileDateGet = useSelector((state) => state.data.dataProfile);

	useEffect(() => {
		// send page view on route change
		analytics.page();
	}, [analytics, location]);

	useEffect(() => {
		if (userToken && userToken.length > 1) {
			if (rol !== 'realestate') {
				dispatch(dataSummary(userToken));
				dispatch(dataProfile(userToken));
				setTimeout(() => {
					setLoading(false);
				}, 3000);
			} else if (rol === 'realestate') {
				dispatch(getOperations());
				dispatch(dataProfile(userToken));
				setTimeout(() => {
					setLoading(false);
				}, 3000);
			} else if (rol === 'client') {
				dispatch(dataSummary(userToken));
				dispatch(dataProfile(userToken));
				setTimeout(() => {
					setLoading(false);
				}, 3000);
			}
		}
	}, [userToken, changeStages]);

	const isSecureUrl = () => {
		let notsecured = ['/login', '/auth/forgot-password', '/auth/reset-password', '/register'];

		return notsecured.findIndex((value) => new RegExp(`^${value}`).test(location.pathname)) === -1;
	};

	if (isSecureUrl() && !isAuthenticated) {
		if (query.token) {
			let customRole;

			if (query.redirect === '/friend') {
				customRole = 'friend';
			}

			const decodedToken = jwt_decode(query.token);

			if (decodedToken.managementCode !== process.env.REACT_APP_BRAND_MANAGEMENT) {
				axios
					.post(
						`https://prometeo.gibobs.com/webhook/9d4bbb62-fda3-463b-8046-7baa00e618d5`,
						{ managementCodePlatform: process.env.REACT_APP_BRAND_MANAGEMENT, jwt: query.token },
						{ headers: { Authorization: `Bearer ${userToken}` } }
					)
					.then(() => {
						document.location =
							process.env.REACT_APP_BRAND === 'office'
								? 'https://tuhipotecabs.bancsabadell.com/'
								: 'https://plataformadehipotecas.bancsabadell.com/';
					});
			} else {
				dispatch(
					getProfile({
						token: query.token,
						navigate,
						redirect: query.redirect,
						customRole
					})
				);
			}
		} else {
			const env = process.env.REACT_APP_NODE_ENV || process.env.NODE_ENV;
			if (env === 'prod') {
				document.location =
					process.env.REACT_APP_BRAND === 'office'
						? 'https://hipotecasbs.bancsabadell.com/'
						: 'https://simuladordehipotecas.bancsabadell.com/';
			} else if (env === 'dev') {
				/*document.location =
					process.env.REACT_APP_BRAND === 'office'
						? 'https://dev.landing.sbp.gibobs.one/'
						: 'https://dev.web.sabadell-es.gibobs.net/';*/
				document.location = '/login'; //'https://dev.web.sabadell-es.gibobs.net/';
			} else if (env === 'staging') {
				document.location =
					process.env.REACT_APP_BRAND === 'office'
						? 'https://staging.landing.sbp.gibobs.one/'
						: 'https://staging.web.sabadell-es.gibobs.net/';
			} else {
				navigate('/login');
			}
		}
	} else if (query.operationId && query.redirect === 'operation-agent-b2b') {
		navigate(`/sales-tools/follow-up/detail-operation/${query.operationId}/basic`);
	} else if (query.redirect === 'loans') {
		navigate(`/my-financial-profile/credits/list`);
	} else if (query.redirect === 'last-promotor-operation') {
		navigate(`/promoter-loan/step-form/${query.operationId}`);
	} else if (!isSecureUrl() && isAuthenticated) {
		navigate('/home');

		return <></>;
	}

	let routesApp = <Routes />;

	if (!isAuthenticated) {
		return (
			<>
				<Layout style={{ height: '100vh' }}>
					<Content style={{ marginTop: 5, minWidth: '70vh' }}>
						<Routes>
							<Route path="/login" element={<LoginPage />} />
							<Route path="/auth/forgot-password" element={<ForgotPasswordPage />} />
							<Route path="/auth/restore-password" element={<RestorePage />} />
						</Routes>
					</Content>
				</Layout>
			</>
		);
	} else {
		const commonRoutes = [<Route key="/home" path="/home" element={<Home></Home>} />];

		if (rol !== 'realestate') {
			routesApp = (
				<Routes>
					<Route path="/payments/operations/:operationId" element={<Payments />} />

					<Route path="/testA*" element={<OnboardingNav />} />
					<Route path="/operations/:operationId/:stage" element={<OperationStage />} />
					<Route path="/documents-offert/:operationId/:stage" element={<OfferDocuments />} />
					<Route path="/operations/:operationId/:stage" element={<OperationStage />} />
					<Route path="operations/:operationId/documents/:owner/opendata" element={<OpenData />} />
					<Route path="/operationNew" element={<RedirectToSabadell />} />
					<Route path="/documents-offert/:operationId/:stage" render={() => <OfferDocuments />} />
					<Route
						path="/:operationId/:owner/automatic-documentation"
						element={<AutomaticDocumentation />}
					/>
					<Route path="/help" element={<Help />} />
					{commonRoutes}
					{/* FIXME: FIXIT */}
					<Route key="/" path="/" element={<Home />} />
				</Routes>
			);
		}
	}

	if (loading) {
		return (
			<div
				style={{
					textAlign: 'center',
					height: '100vh',
					backgroundColor: 'white',
					paddingTop: '35vh'
				}}>
				<LoaderLogo />
			</div>
		);
	}

	return (
		<>
			<TagManager />
			<HeaderComponent />
			<Layout>
				<Content
					className={isMobileOnly && 'mobileComponentScroll'}
					style={{
						marginTop: '1px',
						height: '100vh',
						overflowY: 'scroll',
						position: 'relative',
						backgroundColor: '#F5F5F5'
					}}>
					<div>
						{true && <AlertPassword></AlertPassword>}
						{routesApp}
					</div>
				</Content>
			</Layout>
		</>
	);
};

export default Navigation;
